var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.002,
    height: 26.05,
    viewBox: "0 0 26.002 26.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-phone",
    "data-name": "Icon feather-phone",
    d: "M27.167,21v3.62a2.413,2.413,0,0,1-2.631,2.413,23.881,23.881,0,0,1-10.414-3.7,23.531,23.531,0,0,1-7.24-7.24,23.881,23.881,0,0,1-3.7-10.462A2.413,2.413,0,0,1,5.579,3H9.2a2.413,2.413,0,0,1,2.413,2.076,15.494,15.494,0,0,0,.845,3.391,2.413,2.413,0,0,1-.543,2.546l-1.533,1.533a19.307,19.307,0,0,0,7.24,7.24l1.533-1.533A2.413,2.413,0,0,1,21.7,17.71a15.494,15.494,0,0,0,3.391.845A2.413,2.413,0,0,1,27.167,21Z",
    transform: "translate(-2.167 -2)",
    fill: "none",
    stroke: "#a24b5d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.f44807ec04b570b8067e9bd498e9d55a.svg";
export { ForwardRef as ReactComponent };